import { styled } from '@clickcease/cc-client-components-lib'

export const PricingTabHeaderStyled = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '102px',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0px 8px 11px rgba(227, 232, 242, 0.66)',

  '@bp1': {
    justifyContent: 'flex-start',
    padding: '16px',
    width: 'calc(100% - 32px)',
    height: 'auto',
    backgroundColor: '$white',
  },
})

export const PricingTabHeaderIconWrapper = styled('div', {
  width: '54px',
  height: '54px',
  border: 'solid 1px black',
  borderRadius: '50px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '$8',

  variants: {
    isPm: {
      true: {
        ['> svg']: {
          marginLeft: '$5',
          marginTop: '$5',
        },
      },
    },
  },

  '@bp1': {
    width: '38px',
    height: '28px',
    marginLeft: '18px',
    borderRadius: '39px',
    padding: '11px 5px 10px 6px',
    display: 'flex',
  },
})

export const PricingTabHeaderText = styled('div', {
  color: '$black',
  fontWeight: '$l',
  fontSize: '$h3',

  '@bp1': {
    fontWeight: '$r',
    fontSize: '14px',
    lineHeight: '140%',
  },
})
